/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

import MessageSettingsService from 'cio/services/message-settings';

interface MessagingLimitWorkflowSettingsArgs {
  disabled: boolean;
  useMessageLimits: boolean;
  onChange: (enableLimit: boolean) => unknown;
  hasReadOnlyPermission: boolean;
}

export default class MessagingLimitWorkflowSettings extends Component<MessagingLimitWorkflowSettingsArgs> {
  @service messageSettings!: MessageSettingsService;

  get disabled() {
    return this.args.disabled || this.args.hasReadOnlyPermission || !this.messageSettings.isMessagingLimitEnabled;
  }
}
